var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.waiting)?_c('div',{style:(_vm.css)},[_c('div',{staticClass:"lds-ellipsis",class:_vm.sizeCss},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }